import { dictType } from '@/api/HttpRequestAPI';
import Vue from 'vue'
Vue.prototype.dictMap = {};

export const DICT_TYPES = {
  GKHYFL_TYPES:'gkhyfl_types', //归口行业分类
  ACADEMIC_DEGREE:'academic_degree', //学位
  CYLB:'cylb', //产业类别
}


export const getDictByKey = (key) => {
  return new Promise(function (resolve, reject) {
    if(Vue.prototype.dictMap[key]) {
      resolve(Vue.prototype.dictMap[key])
    } else {
      dictType({dictType:key}, (resp)=>{
        let dictList = resp.data ? resp.data : []
        dictList = dictList.map(data=>{
          return {
            label:data.dictLabel,
            value:data.dictValue
          }
        })
        Vue.prototype.dictMap[key] = dictList
        resolve(dictList);
      })
    }

  });
};


